export default {
  light: {
    logo: "KIDO_horizontal_black.png",
    type: "light",
    background: "bg-light",
    primaryColor: "#822ed8",
    fontColor: "rgb(0,0,0, 0.5)",
    borderColor: "rgba(0,0,0, 0.2)",
    dateFormat: "YYYY-MM-DD",
    svg: {
      primary: "#2BD7B8",
      secondary: "#2D5D7C",
      tertiary: "#33B9E3",
      quaternary: "#EF5939"
    },
    colors: [
      "#2BD7B8",
      "#2D5D7C",
      "#33B9E3",
      "#EF5939",
      "#B3CDD1",
      "#748386",
      "#9E768F",
      "#725AC1",
      "#ff2f92",
      "#7030a0",
      "#056950",
      "#8E5EA2",
      "#E8C3B9",
      "#3E95CD",
      "#0DD9A4",
      "#056950",
      "#8E5EA2",
      "#E8C3B9",
      "#BBDEDE",
      "#F8D0CB",
      "#FF9EC6"
    ]
  },
  dark: {
    logo: "KIDO_horizontal_white.png",
    type: "dark",
    background: "bg-dark",
    primaryColor: "#822ed8",
    fontColor: "rgb(255,255,255, 0.5)",
    borderColor: "rgba(0,0,0, 0.2)",
    dateFormat: "DD-MM-YYYY",
    svg: {
      primary: "#2BD7B8",
      secondary: "#2D5D7C",
      tertiary: "#33B9E3",
      quaternary: "#EF5939"
    },
    colors: [
      "#2BD7B8",
      "#2D5D7C",
      "#33B9E3",
      "#EF5939",
      "#B3CDD1",
      "#748386",
      "#9E768F",
      "#725AC1",
      "#ff2f92",
      "#7030a0",
      "#056950",
      "#8E5EA2",
      "#E8C3B9",
      "#3E95CD",
      "#0DD9A4",
      "#056950",
      "#8E5EA2",
      "#E8C3B9",
      "#BBDEDE",
      "#F8D0CB",
      "#FF9EC6"
    ]
  }
};
